import { SafiVatEnum } from 'api';
import { yup } from 'form';

import { basePurchaseOrderFormSchema } from './basePurchaseOrderSchema';

export const updatePurchaseOrderSchema = basePurchaseOrderFormSchema
  .shape({
    date_fixed: yup.string().optional(),
    fixed_price: yup.string().optional(),
    number_of_loads: yup.string().required(),
    safi_vat: yup.string().oneOf(Object.values(SafiVatEnum)).optional(),
  })
  .test('fixed-price-date-dependency', 'Fixed price and fixed date must be provided together', function (values) {
    const hasFixedPrice = values.fixed_price !== undefined && values.fixed_price !== '';
    const hasFixedDate = values.date_fixed !== undefined && values.date_fixed !== '';

    if ((hasFixedPrice && !hasFixedDate) || (!hasFixedPrice && hasFixedDate)) {
      return this.createError({
        message: 'Fixed price and fixed date must be provided together',
        path: hasFixedPrice ? 'fixed_date' : 'fixed_price',
      });
    }

    return true;
  });
